import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { formatDate } from '../../../utils/dateUtils';
import { Button } from "react-bootstrap";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css"; // optional theme

const TasksOverview = () => {
  const [dates, setDates] = useState([]);
  const [filteredDates, setFilteredDates] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_WEB_SERVICES_URL}/admin/get-tasks-by-date`, {
      withCredentials: true,
    }).then(res => {
      if (res.data.status) {
        setDates(res.data.tasks);
        setFilteredDates(res.data.tasks);
      }
    });
  }, []);

  const filterByDate = () => {
    if (!startDate && !endDate) {
      setFilteredDates(dates);
      return;
    }

    const filtered = dates.filter(item => {
      const d = new Date(item.task_date);
      if (startDate && d < startDate) return false;
      if (endDate && d > endDate) return false;
      return true;
    });

    setFilteredDates(filtered);
  };

  const resetFilter = () => {
    setStartDate(null);
    setEndDate(null);
    setFilteredDates(dates);
  };

  return (
    <div className="container-fluid px-4 mt-4">
      <div className='row mb-3'>
        <h3>View Task</h3>
      </div>

      {/* DATE RANGE FILTER */}
      <div className="card shadow p-3 mb-4">
        <div className="row g-3 align-items-end">
          <div className="col-md-3">
            <label className="form-label">Start Date</label>
            <Flatpickr
              value={startDate}
              onChange={(date) => setStartDate(date[0] || null)}
              options={{ dateFormat: "Y-m-d", allowInput: true }}
              className="form-control"
              placeholder="YYYY-MM-DD"
            />
          </div>

          <div className="col-md-3">
            <label className="form-label">End Date</label>
            <Flatpickr
              value={endDate}
              onChange={(date) => setEndDate(date[0] || null)}
              options={{ dateFormat: "Y-m-d", allowInput: true }}
              className="form-control"
              placeholder="YYYY-MM-DD"
            />
          </div>

          <div className="col-md-2">
            <Button className="w-100" variant="primary" onClick={filterByDate}>
              Filter
            </Button>
          </div>

          <div className="col-md-2">
            <Button className="w-100" variant="secondary" onClick={resetFilter}>
              Reset
            </Button>
          </div>
        </div>
      </div>

      {/* TABLE */}
      <div className="card shadow mt-4">
        <div className="card-body p-4">
          <div className="table-responsive">
            <table className="table table-bordered table-hover shadow-sm nowrap">
              <thead className="table-success">
                <tr>
                  <th>#</th>
                  <th>Date</th>
                  <th>Tasks</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredDates.length > 0 ? (
                  filteredDates.map((d, idx) => (
                    <tr key={d.task_date}>
                      <td>{idx + 1}</td>
                      <td>{formatDate(d.task_date)}</td>
                      <td>{d.task_count}</td>
                      <td>
                        <Button
                          variant="info"
                          size="sm"
                          onClick={() => navigate(`/admin/tasks/view/${d.task_date}`)}
                        >
                          View
                        </Button>
                        <Link
                          to={`/admin/tasks/print/${d.task_date}`}
                          className="btn btn-sm ms-1 btn-secondary"
                          target="_blank"
                        >
                          Print
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No task dates found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TasksOverview;
